import ApiConstant from "../../constants/api.constants";
import api from "../api";

/**
 * Upload a profile picture to Azure Blob Storage.
 * Sends the file as multipart/form-data to the UploadProfilePicture endpoint.
 */
const uploadProfilePicture = async (file: File): Promise<any> => {
    try {
        const formData = new FormData();
        formData.append("file", file);

        const response = await api.post(ApiConstant.uploadProfilePicture, formData, {
            headers: {
                "content-type": "multipart/form-data",
            }
        });

        return response.data;
    } catch (error: any) {
        const errorMessage = error.response?.data?.message || error.message || "An unknown error occurred during upload.";
        throw errorMessage;
    }
};

/**
 * Retrieve the profile picture URL from Azure Blob Storage.
 * Uses the GetAzureBlobFile endpoint with fileName=userId.webp and container=user-profiles.
 */
const getProfilePictureUrl = async (userId: number): Promise<string | null> => {
    try {
        const response = await api.get(ApiConstant.getAzureBlobFile, {
            params: {
                fileName: `${userId}.webp`,
                container: "user-profiles",
            }
        });

        if (response && response.data && response.data.url) {
            return response.data.url;
        }
        return null;

    } catch (error: any) {
        throw error;
    }
};

const ProfilePictureService = {
    uploadProfilePicture,
    getProfilePictureUrl,
};

export default ProfilePictureService;